import { useQuery } from '@tanstack/react-query';
import { queryFn, getDividendsTimeseriesDataKey } from './queryFn';

export const useDividendsData = (id: string) => {
  return useQuery({
    queryKey: getDividendsTimeseriesDataKey(id),
    queryFn,
    staleTime: 3600000,
    enabled: !!id,
  });
};
